export class StringHelper {
    static Truncate(str: any, length: number) {
        var dots = str.length > length ? '...' : '';
        return str.substring(0, length) + dots;
    }
}